<template>
  <v-layout>
    <slot></slot>
  </v-layout>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
